export default function WhatIsGenesis() {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              What is the Genesis Mission?
            </h2>
            <p className="text-xl text-gray-600">
              A national initiative to unify AI, advanced scientific computing, and cross-disciplinary research
            </p>
          </div>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 leading-relaxed mb-6">
              The <strong>Genesis Mission</strong>, launched by the U.S. Department of Energy (DOE) in late 2025, 
              is an ambitious national effort to unify AI, advanced scientific computing, and cross-disciplinary 
              research under a single AI-augmented discovery ecosystem. The Mission will draw on DOE's 17 
              National Laboratories and its compute, quantum, materials science, and energy research infrastructure.
            </p>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              While Genesis is <strong>not a binding federal regulation</strong>, it creates a powerful new alignment 
              point for organizations preparing for potential participation, collaboration, proposal cycles, and 
              integration requests.
            </p>
            
            <div className="bg-primary-50 border-l-4 border-primary-600 p-6 rounded-r-lg my-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                Who Should Prepare?
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Energy-sector software vendors</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Grid operations technology providers</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Applied AI companies</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Scientific computing partners</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Federal contractors</span>
                </li>
                <li className="flex items-start">
                  <span className="text-primary-600 mr-2">•</span>
                  <span>Industrial R&D teams (materials, climate, fusion, power)</span>
                </li>
              </ul>
            </div>
            
            <p className="text-gray-700 leading-relaxed">
              <strong>Harbor Agent's value is simple:</strong> We translate large, ambiguous government initiatives 
              into developer-ready artifacts and AI-native workflows that your team can actually use. The Genesis Mission 
              Readiness Pack is Pack #1 in the Harbor Agent line.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

